import React, { useEffect, useRef, useState } from 'react'

import { get } from '@js/common/api'

import ListPagination from '@f-fertighaus/applications/OfficeMap/partials/ListPagination'
import OfficeDetail from './OfficeDetail'
import OfficeDetailCard from './OfficeDetailCard'
import RefreshMapCTA from './RefreshMapCTA'

const DesktopView = ({
  actions: { applyQuery, setActiveID, updateQuery },
  data: {
    apiResponse: { results = [], count = 0 },
    showApplyQueryCTA,
    displayingFilters,
    params,
    activeID,
    activeIDonMap
  },
  desktopWrap = {}
}) => {
  const [selectedOffice, setSelectedOffice] = useState(null)

  const handleMouseInteraction = ({ event, interaction, office }) => {
    if (interaction === 'select') {
      event.preventDefault()
      setSelectedOffice(office.nid)
    } else if (interaction === 'hover') {
      setActiveID(office.nid)
    } else {
      if (document.querySelector(`#${event.target.nid}`)) setActiveID(null)
    }
  }

  useEffect(() => {
    if (activeID && selectedOffice && selectedOffice !== activeID) {
      setSelectedOffice(activeID)
    }

    if (activeID && desktopWrap.current && !officeDetails.office) {
      const elementsHovered = document.querySelectorAll(':hover')
      let foundListElement = false
      for (const element of elementsHovered) {
        if (/DesktopView-wrap/.test(element.className)) {
          foundListElement = true
        }
      }

      if (
        !foundListElement &&
        desktopWrap.current.querySelector(`#office_${activeID}`)
      ) {
        desktopWrap.current.scrollTop =
          desktopWrap.current.querySelector(`#office_${activeID}`).offsetTop -
          16
      }
    }
  }, [activeID])

  const [officeDetails, setOfficeDetails] = useState({ initial: true })

  useEffect(() => {
    if (selectedOffice) {
      const officeInfo = results.find(office => office.nid === selectedOffice)

      get('vendors', {
        nid__in: officeInfo.vendor_nid
      }).then(data => {
        setOfficeDetails({
          office: officeInfo,
          vendor: data.results[0]
        })
      })
    } else {
      if (officeDetails.initial !== true) setOfficeDetails({})
    }
  }, [selectedOffice])

  useEffect(() => {
    if (officeDetails.office && displayingOfficeDetails) {
      desktopViewPanel.current.classList.add('is-hidden')

      setTimeout(() => {
        setDisplayingOfficeDetails(false)
        setActiveID(activeIDonMap)
        setSelectedOffice(activeIDonMap)
      }, 250)
    } else {
      setActiveID(activeIDonMap)
    }
  }, [activeIDonMap])

  useEffect(() => {
    setSelectedOffice(null)
    setDisplayingOfficeDetails(false)
    setDisplayingOfficesList(true)
  }, [results])

  const desktopViewPanel = useRef(null)

  useEffect(() => {
    if (officeDetails.office) {
      desktopViewPanel.current.classList.add('is-hidden')

      setTimeout(() => {
        if (desktopWrap.current) {
          desktopWrap.current.classList.remove('has-smooth-scrolling')
          desktopWrap.current.scrollTop = 0
        }

        setDisplayingOfficesList(false)
        setDisplayingOfficeDetails(true)

        setTimeout(() => {
          if (desktopWrap.current) {
            desktopWrap.current.classList.add('has-smooth-scrolling')
          }

          desktopViewPanel.current.classList.remove('is-hidden')
        }, 250)
      }, 250)
    }
  }, [officeDetails])

  const goBackToList = () => {
    desktopViewPanel.current.classList.add('is-hidden')

    if (desktopWrap.current) {
      desktopWrap.current.classList.remove('has-smooth-scrolling')
    }

    setTimeout(() => {
      setDisplayingOfficeDetails(false)
      setDisplayingOfficesList(true)
      setSelectedOffice(null)

      setTimeout(() => {
        if (desktopWrap.current) {
          if (activeID) {
            desktopWrap.current.scrollTop =
              desktopWrap.current.querySelector(`#office_${activeID}`)
                .offsetTop - 16
          }

          desktopWrap.current.classList.add('has-smooth-scrolling')
        }

        desktopViewPanel.current.classList.remove('is-hidden')
      }, 250)
    }, 250)
  }

  const [displayingOfficeDetails, setDisplayingOfficeDetails] = useState(false)
  const [displayingOfficesList, setDisplayingOfficesList] = useState(true)

  const propsForPartials = {
    actions: { updateQuery },
    data: {
      apiResponse: { results, count },
      params
    }
  }

  return (
    <div className='OfficeMap-DesktopView-panel' ref={desktopViewPanel}>
      {displayingOfficeDetails && officeDetails.office ? (
        <OfficeDetail
          officeDetails={officeDetails}
          setSelectedOffice={goBackToList}
        />
      ) : null}
      {displayingOfficesList ? (
        <>
          <div className='[ f-p-h-020 f-p-t-020 f-t-body ]'>
            {count} Einträge
          </div>
          <div className='[ f-p-h-020 f-p-b-020 ]'>
            {results.map(office => {
              return (
                <button
                  key={office.nid}
                  id={`office_${office.nid}`}
                  className={`[ f-pos-rel f-radius-card-medium f-shadow-strong f-m-t-020 f-p-a-0 ] OfficeMap-list-item ${
                    office.nid === activeID ? 'is-highlighted' : ''
                  }`}
                  onMouseEnter={event =>
                    handleMouseInteraction({
                      event,
                      interaction: 'hover',
                      office
                    })
                  }
                  onMouseLeave={event =>
                    handleMouseInteraction({
                      event,
                      interaction: 'unhover',
                      office
                    })
                  }
                  onClick={event =>
                    handleMouseInteraction({
                      event,
                      interaction: 'select',
                      office
                    })
                  }>
                  <OfficeDetailCard type='list' item={office} />
                </button>
              )
            })}
          </div>
          <RefreshMapCTA
            applyQuery={applyQuery}
            displayingFilters={displayingFilters}
            showApplyQueryCTA={showApplyQueryCTA}
            isBottom
          />
          <ListPagination {...propsForPartials} />
        </>
      ) : null}
    </div>
  )
}

export default DesktopView
